import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'md-kanban-form-cheque-retrait-dialog',
    templateUrl: './md-kanban-form-cheque-retrait-dialog.component.html',
})
export class MdKanbanFormChequeRetraitDialogComponent implements OnInit {
    loading = false;
    itemForm = this._formBuilder.group({
        CLIENT: [null, Validators.required],
    });
    kanbanItem: any;
    item?: any;
    startupInfos: any;
    
    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<MdKanbanFormChequeRetraitDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { kanbanItem: any, startupInfos: any, item?: any },
    ) {
        this.kanbanItem = data.kanbanItem;
        this.startupInfos = data.startupInfos;
        this.item = data.item;
        if (!!data.item) {
            this.itemForm.patchValue({
                CLIENT: data.item.PARAMS_TASK.CLIENT
            });
        }
    }

    ngOnInit() {
    }

    get f() {
        return this.itemForm.controls;
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit(renew: boolean) {
        if (this.itemForm.invalid) { return; }
        this.dialogRef.close({ data: this.itemForm.value, renew: renew });
    }

    onClientSelected(clientId: any) {
        const client = this.startupInfos.CLIENTS.find(b => b.ID == clientId);
        if (!!client) {
            this.itemForm.controls.CLIENT.patchValue(client);
        }
    }
}